import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { RootStateTypeExtra, Token } from '@store/types'

export interface TokenInterface {
  access_token: Token
  refresh_token: Token
  email: string
  _id: string
}

const tokens = localStorage.getItem('tokens')

let initialState = {
  access_token: {
    token: '',
    expires_at: '',
    _id: '',
  },
  refresh_token: {
    token: '',
    expires_at: '',
    _id: '',
  },
  email: '',
  _id: '',
} as TokenInterface

if (tokens) {
  initialState = JSON.parse(tokens)
}

const tokenSlice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    setToken: (
      state: TokenInterface,
      action: PayloadAction<TokenInterface>
    ) => {
      localStorage.setItem('tokens', JSON.stringify(action.payload))
      return {
        ...state,
        ...action.payload,
      }
    },
    removeToken: (state: TokenInterface) => {
      localStorage.removeItem('tokens')
      return {
        ...state,
        ...{
          access_token: {
            token: '',
            expires_at: '',
            _id: '',
          },
          refresh_token: {
            token: '',
            expires_at: '',
            _id: '',
          },
          email: '',
          _id: '',
        },
      }
    },
  },
})

export const { setToken, removeToken } = tokenSlice.actions

export const selectToken = (state: RootStateTypeExtra) => state.token

export default tokenSlice.reducer
